/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import {
  Modal,
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { v4 as uuidv4 } from 'uuid';
import $ from 'jquery';
import { Scrollbars } from 'react-custom-scrollbars-2';
import cx from 'classnames';
import Loader from '../Loader/Loader';
import api from '../../api';
import closeBtn from '../../images/components/new_scan/close-btn.svg';

class EditLDAPModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMEL: props.isOpenMEL,
      isLoader: false,
      modalAlert: false,
      modalAlertTitle: '',
      modalAlertMsg: '',
      use_ldap: false,
      globalError: '',
      ldapName: '',
      host: '',
      port: '',
      root_dn: '',
      filter: '',
      manage_dn: '',
      manage_pw: '',
      auto_sync: false,
      auto_sync_time: '',
      nameError: false,
      managePwError: false,
      manageDnError: false,
      rootDnError: false,
      portError: false,
      hostError: false,
      nameErrorMsg: '',
      hostErrorMsg: '',
      portErrorMsg: '',
      rootDnErrorMsg: '',
      manageDnErrorMsg: '',
      managePwErrorMsg: '',
    };
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleHostChange = this.handleHostChange.bind(this);
    this.handlePortChange = this.handlePortChange.bind(this);
    this.handleRootDnChange = this.handleRootDnChange.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleManageDnChange = this.handleManageDnChange.bind(this);
    this.handleManagePwChange = this.handleManagePwChange.bind(this);
    this.handleCloseAlert = this.handleCloseAlert.bind(this);
    this.handleAutoSync = this.handleAutoSync.bind(this);
    this.handleAutoSyncTime = this.handleAutoSyncTime.bind(this);
    this.handleRemoveLDAP = this.handleRemoveLDAP.bind(this);
    this.handleMDLClose = this.handleMDLClose.bind(this);
    this.handleDeleteLDAP = this.handleDeleteLDAP.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleUseLDAP = this.handleUseLDAP.bind(this);
    this.validation = this.validation.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseover', '.setting_popup .table_type_3 .strong', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps) {
    const { isOpenMEL, ldapId } = this.props;

    if (prevProps.isOpenMEL !== isOpenMEL) {
      this.setState({
        isOpenMEL,
        isLoader: false,
        use_ldap: false,
        modalAlert: false,
        modalAlertTitle: '',
        modalAlertMsg: '',
        globalError: '',
        ldapName: '',
        host: '',
        port: '',
        root_dn: '',
        filter: '',
        manage_dn: '',
        manage_pw: '',
        auto_sync: false,
        auto_sync_time: '',
        nameError: false,
        managePwError: false,
        manageDnError: false,
        rootDnError: false,
        portError: false,
        hostError: false,
        nameErrorMsg: '',
        hostErrorMsg: '',
        portErrorMsg: '',
        rootDnErrorMsg: '',
        manageDnErrorMsg: '',
        managePwErrorMsg: '',
      }, () => {
        if (isOpenMEL) {
          this.getCurrentLdap(ldapId);
        }
      });
    }
  }

  handleNameChange(e) {
    const { translate } = this.props;
    if (this.getByteLength(e.target.value) > 20) {
      return this.setState({
        nameError: true,
        nameErrorMsg: translate('modal.message.limit_ldap_name'),
      });
    }

    this.setState({
      ldapName: e.target.value,
      nameError: false,
      nameErrorMsg: '',
    });
  }

  handleHostChange(e) {
    this.setState({
      host: e.target.value,
      hostError: false,
      hostErrorMsg: '',
    });
  }

  handlePortChange(e) {
    this.setState({
      port: e.target.value,
      portError: false,
      portErrorMsg: '',
    });
  }

  handleRootDnChange(e) {
    this.setState({
      root_dn: e.target.value,
      rootDnError: false,
      rootDnErrorMsg: '',
    });
  }

  handleFilterChange(e) {
    this.setState({
      filter: e.target.value,
    });
  }

  handleManageDnChange(e) {
    this.setState({
      manage_dn: e.target.value,
      manageDnError: false,
      manageDnErrorMsg: '',
    });
  }

  handleManagePwChange(e) {
    this.setState({
      manage_pw: e.target.value,
      managePwError: false,
      managePwErrorMsg: '',
    });
  }

  handleAutoSync(e) {
    let useSync;
    const { value } = e.target;
    if (value === 'on') {
      useSync = true;
    } else {
      useSync = false;
    }

    this.setState({
      auto_sync: useSync,
    });
  }

  handleUseLDAP(e) {
    let useLDAP;
    const { value } = e.target;
    if (value === 'on') {
      useLDAP = true;
    } else {
      useLDAP = false;
    }

    this.setState({
      use_ldap: useLDAP,
    });
  }

  handleAutoSyncTime(e) {
    this.setState({
      auto_sync_time: e.target.value,
    });
  }

  handleRemoveLDAP() {
    this.setState({
      isOpenMDL: true,
    });
  }

  handleMDLClose() {
    this.setState({
      isOpenMDL: false,
    });
  }

  handleDeleteLDAP() {
    const { translate, ldapId } = this.props;
    api
      .deleteCurrentLDAP(ldapId)
      .then(() => {
        this.handleCloseAlert();
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;

        if (o.error_description) {
          this.setState({
            isLoader: false,
            isOpenMDL: false,
            globalError: o.error_description,
          });
        } else if (o.error === '422-752') {
          this.setState({
            isLoader: false,
            isOpenMDL: false,
            globalError: translate('modal.erorr.invalid_access'),
          });
        }
      });
  }

  handleSave() {
    if (!this.validation()) {
      return;
    }

    const {
      ldapName,
      host,
      port,
      root_dn,
      filter,
      manage_dn,
      manage_pw,
      auto_sync,
      auto_sync_time,
      use_ldap,
    } = this.state;
    const { translate, ldapId } = this.props;

    const newObj = {
      use_ldap,
      name: ldapName,
      host,
      port,
      base_dn: root_dn,
      filter,
      manage_dn,
      manage_pw,
      auto_sync,
      auto_sync_time: Number(auto_sync_time),
    };

    this.setState({
      modalAlert: true,
      isLoader: true,
    }, () => {
      api
        .updateCurrentLdap(ldapId, newObj)
        .then(() => {
          this.setState({
            isLoader: false,
            modalAlertTitle: translate('modal.title.notice'),
            modalAlertMsg: translate('modal.message.ldap_update_success'),
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;

          if (o.error_description) {
            this.setState({
              isLoader: false,
              modalAlert: false,
              globalError: o.error_description,
            });
          } else if (o.error === '422-362') {
            this.setState({
              isLoader: false,
              modalAlert: false,
              globalError: translate('modal.error.error_permission_ldap'),
            });
          } else if (o.error === '422-051') {
            this.setState({
              isLoader: false,
              modalAlert: false,
              nameError: true,
              nameErrorMsg: translate('modal.error.error_422_051'),
            });
          } else if (o.error === '422-751') {
            this.setState({
              isLoader: false,
              modalAlert: false,
              globalError: translate('modal.error.error_422_751'),
            });
          } else {
            this.setState({
              isLoader: false,
              modalAlert: false,
              globalError: translate('modal.error.unknow_error'),
            });
          }
        });
    });
  }

  handleCloseAlert() {
    this.setState({
      modalAlert: false,
      isOpenMEL: false,
      isOpenMDL: false,
    }, () => {
      this.props.updateLdapCallback();
    });
  }

  getCurrentLdap = (id) => {
    const { translate } = this.props;
    api
      .getCurrentLdap(id)
      .then((response) => {
        const data = response.response;
        this.setState({
          //ldap_priority: data.ldap_priority,
          ldapName: data.name,
          host: data.host,
          port: data.port,
          root_dn: data.base_dn,
          filter: data.filter,
          manage_dn: data.manage_dn,
          manage_pw: '',
          use_ldap: data.use_ldap,
          auto_sync: data.auto_sync,
          auto_sync_time: data.auto_sync_time,
          //isLoading: false,
        });
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;

        if (o.error_description) {
          this.setState({
            //isLoader: false,
            globalError: o.error_description,
          });
        } else if (o.error === '422-362') {
          this.setState({
            //isLoader: false,
            globalError: translate('modal.error.error_update_permission_ldap'),
          });
        } else if (o.error === '422-752') {
          this.setState({
            //isLoader: false,
            globalError: translate('modal.erorr.invalid_access'),
          });
        }
      });
  };

  getByteLength(text) {
    let l = 0;
    for (let i = 0; i < text.length; i++) l += (text.charCodeAt(i) > 128) ? 2 : 1;
    // return text.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, '$&$1$2').length;
    return l;
  }

  closeModal() {
    this.setState({
      isOpenMEL: false,
    });
    this.props.closeModal();
  }

  validation() {
    const { translate } = this.props;
    const { use_ldap } = this.state;

    if (!use_ldap) {
      return true;
    }

    if (this.refs.name.value === '') {
      this.setState({
        nameError: true,
        nameErrorMsg: translate('system.message.required_name'),
      });
      return false;
    }

    if (this.refs.host.value === '') {
      this.setState({
        hostError: true,
        hostErrorMsg: translate('system.message.required_host'),
      });
      return false;
    }

    if (this.refs.port.value === '') {
      this.setState({
        portError: true,
        portErrorMsg: translate('system.message.required_port'),
      });
      return false;
    }

    if (this.refs.rootDn.value === '') {
      this.setState({
        rootDnError: true,
        rootDnErrorMsg: translate('system.message.required_base_dn'),
      });
      return false;
    }

    if (this.refs.manageDn.value === '') {
      this.setState({
        manageDnError: true,
        manageDnErrorMsg: translate('system.message.required_manager_dn'),
      });
      return false;
    }

    if (this.refs.managePw.value === '') {
      this.setState({
        managePwError: true,
        managePwErrorMsg: translate('system.message.required_manager_password'),
      });
      return false;
    }

    return true;
  }

  render() {
    const { translate } = this.props;
    const globalErrorClass = this.state.globalError !== '' ? 'show' : '';
    const currentLocale = localStorage.getItem('i18nextLng');

    return (
      <Modal
        open={this.state.isOpenMEL}
        onClose={this.closeModal}
      >
        <div className="setting_popup_wrap">
          <div className="setting_popup default_popup has_popup_inner_menu setting_type_2 systems_popup">
            <div className="setting_popup_header">
              <h2 className="popup_name">{translate('modal.title.detail_ldap')}</h2>
              <div
                className={`error ${globalErrorClass}`}
                style={{
                  fontSize: '15px',
                  fontWeight: '700',
                  color: '#ef4136',
                }}
              >
                {this.state.globalError}
              </div>
              <a
                className="popup_close_button"
                onClick={this.closeModal}
              >
                <img src={closeBtn} alt="" />
              </a>
            </div>
            <Scrollbars
              style={{
                position: 'relative',
                overflow: 'hidden',
                height: '100%',
              }}
            >
              <div className="setting_contnets">
                {/**setting_popup_content_wrap */}
                <div className="setting_contnet_wrap">
                  <div
                    className={cx('left_content', {
                      disable: !this.state.use_ldap,
                    })}
                  >
                    <h3 className="setting_content_title">{translate('system.list.name')}</h3>
                    <div className="setting_content">
                      <input
                        type="text"
                        className="setting_input"
                        //placeholder="e.g. LDAP name"
                        value={this.state.ldapName}
                        onChange={this.handleNameChange}
                        ref="name"
                      />
                      <div className={cx('error', { show: this.state.nameError })}>
                        {this.state.nameErrorMsg}
                      </div>
                    </div>
                  </div>
                  <div
                    className={cx('right_content', {
                      disable: !this.state.use_ldap,
                    })}
                  >
                    <h3 className="setting_content_title">{translate('system.list.host')}</h3>
                    <div className="setting_content">
                      <input
                        type="text"
                        className="setting_input"
                        placeholder={`${translate('system.list.example')} 127.0.0.1`}
                        value={this.state.host}
                        onChange={this.handleHostChange}
                        ref="host"
                      />
                      <div className={cx('error', { show: this.state.hostError })}>
                        {this.state.hostErrorMsg}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="setting_contnet_wrap">
                  <div
                    className={cx('left_content', {
                      disable: !this.state.use_ldap,
                    })}
                  >
                    <h3 className="setting_content_title">{translate('system.list.port')}</h3>
                    <div className="setting_content">
                      <input
                        type="text"
                        className="setting_input"
                        placeholder={`${translate('system.list.example')} 389`}
                        value={this.state.port}
                        onChange={this.handlePortChange}
                        ref="port"
                      />
                      <div className={cx('error', { show: this.state.portError })}>
                        {this.state.portErrorMsg}
                      </div>
                    </div>
                  </div>
                  <div
                    className={cx('right_content', {
                      disable: !this.state.use_ldap,
                    })}
                  >
                    <h3 className="setting_content_title">{translate('system.list.base_dn')}</h3>
                    <div className="setting_content">
                      <input
                        type="text"
                        className="setting_input"
                        placeholder={`${translate('system.list.example')} dc=insignary, dc=com`}
                        value={this.state.root_dn}
                        onChange={this.handleRootDnChange}
                        ref="rootDn"
                        autoComplete="new-password"
                      />
                      <div className={cx('error', { show: this.state.rootDnError })}>
                        {this.state.rootDnErrorMsg}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="setting_contnet_wrap">
                  <div
                    className={cx('left_content', {
                      disable: !this.state.use_ldap,
                    })}
                  >
                    <h3 className="setting_content_title">{translate('system.list.filter')}</h3>
                    <div className="setting_content">
                      <input
                        type="text"
                        className="setting_input"
                        onChange={this.handleFilterChange}
                        value={this.state.filter}
                        ref="filter"
                      />
                    </div>
                    <div className="text">
                      {translate('system.message.ldap_sync_filter')}
                      <br />
                      {translate('system.message.ldap_sync_filter_sub')}
                    </div>
                  </div>
                  <div
                    className={cx('right_content', {
                      disable: !this.state.use_ldap,
                    })}
                  >
                    <h3 className="setting_content_title">{translate('system.list.manager_dn')}</h3>
                    <div className="setting_content">
                      <input
                        type="text"
                        className="setting_input"
                        placeholder={`${translate('system.list.example')} cn=admin, dc=insignary, dc=com`}
                        onChange={this.handleManageDnChange}
                        value={this.state.manage_dn}
                        ref="manageDn"
                      />
                      <div
                        className={cx('error', {
                          show: this.state.manageDnError,
                        })}
                      >
                        {this.state.manageDnErrorMsg}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="setting_contnet_wrap">
                  <div className="left_content">
                    <div className="left_content">
                      <h3 className="setting_content_title">{translate('modal.title.enable_ldap_usage')}</h3>
                      <div className="setting_content">
                        <select
                          ref="useLDAP"
                          value={this.state.use_ldap ? 'on' : 'off'}
                          onChange={this.handleUseLDAP}
                        >
                          <option value="on">{translate('system.button.on_uppercase')}</option>
                          <option value="off">{translate('system.button.off_uppercase')}</option>
                        </select>
                      </div>
                    </div>
                    <div
                      className={cx('right_content', {
                        disable: !this.state.use_ldap,
                      })}
                    >
                      <h3 className="setting_content_title">{translate('system.list.manager_password')}</h3>
                      <div className="setting_content">
                        <input
                          type="password"
                          className="setting_input"
                          onChange={this.handleManagePwChange}
                          value={this.state.manage_pw}
                          ref="managePw"
                          autoComplete="new-password"
                        />
                        <div
                          className={cx('error', {
                            show: this.state.managePwError,
                          })}
                        >
                          {this.state.managePwErrorMsg}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={cx('right_content', {
                      disable: !this.state.use_ldap,
                    })}
                  >
                    <h3 className="setting_content_title">{translate('system.list.auto_ldap_sync')}</h3>
                    <div className="setting_content">
                      <table className="table">
                        <colgroup>
                          <col style={{ width: '112px' }} />
                          <col style={{ width: '' }} />
                          <col style={{ width: '112px' }} />
                          <col style={{ width: '92px' }} />
                        </colgroup>
                        <tbody>
                          <tr>
                            <td>
                              <select
                                ref="autoSync"
                                value={this.state.auto_sync ? 'on' : 'off'}
                                onChange={this.handleAutoSync}
                                disabled={!this.state.use_ldap}
                              >
                                <option value="on">{translate('system.button.on_uppercase')}</option>
                                <option value="off">{translate('system.button.off_uppercase')}</option>
                              </select>
                            </td>
                            <th className="tar">{translate('system.list.every_day_at')}</th>
                            <td>
                              {
                                currentLocale === 'kr' || currentLocale === 'ja' ? (
                                  <select
                                    ref="autoSyncTime"
                                    value={this.state.auto_sync_time}
                                    onChange={this.handleAutoSyncTime}
                                    disabled={!this.state.auto_sync || !this.state.use_ldap}
                                  >
                                    {[...Array(12)].map((x, i) => {
                                      return (
                                        <option key={uuidv4()} value={i + 1}>
                                          {translate('system.list.am')}
                                          {i + 1 < 10 ? '0'.concat(i + 1) : i + 1}
                                          {translate('system.list.hour')}
                                        </option>
                                      );
                                    })}
                                    {[...Array(12)].map((x, i) => {
                                      return (
                                        <option key={uuidv4()} value={(i + 13) % 24}>
                                          {translate('system.list.pm')}
                                          {i + 1 < 10 ? '0'.concat(i + 1) : i + 1}
                                          {translate('system.list.hour')}
                                        </option>
                                      );
                                    })}
                                  </select>
                                ) : (
                                  <select
                                    ref="autoSyncTime"
                                    value={this.state.auto_sync_time}
                                    onChange={this.handleAutoSyncTime}
                                    disabled={!this.state.auto_sync || !this.state.use_ldap}
                                  >
                                    {[...Array(12)].map((x, i) => {
                                      return (
                                        <option key={uuidv4()} value={i + 1}>
                                          {i + 1 < 10 ? '0'.concat(i + 1) : i + 1}
                                          {translate('system.list.am')}
                                        </option>
                                      );
                                    })}
                                    {[...Array(12)].map((x, i) => {
                                      return (
                                        <option key={uuidv4()} value={(i + 13) % 24}>
                                          {i + 1 < 10 ? '0'.concat(i + 1) : i + 1}
                                          {translate('system.list.pm')}
                                        </option>
                                      );
                                    })}
                                  </select>
                                )
                              }
                            </td>
                            <td>
                              {/**
                                <a className="gray_button">
                                  Sync Now
                                </a>
                              */}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="setting_popup_bottom">
                  <a
                    className="red"
                    style={{
                      cursor: 'pointer', lineHeight: '25px', height: '25px', display: 'inline-block'
                    }}
                    onClick={this.handleRemoveLDAP}
                  >
                    {translate('modal.button.delete_this_ldap')}
                  </a>
                </div>
              </div>
            </Scrollbars>
            <div className="setting_popup_button_wrap">
              <a
                className="button cencel_button"
                onClick={this.closeModal}
                style={{ cursor: 'pointer' }}
              >
                {translate('modal.button.cancel')}
              </a>
              <a
                className="button save_button"
                onClick={this.handleSave}
                style={{ cursor: 'pointer' }}
              >
                {translate('modal.button.save')}
              </a>
            </div>
          </div>
        </div>
        <Modal open={this.state.modalAlert} onClose={this.handleCloseAlert}>
          {this.state.isLoader ? (
            <Loader />
          ) : (
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{this.state.modalAlertTitle}</h2>
                  <p className="text">{this.state.modalAlertMsg}</p>
                  <div className="button_wrap">
                    <a
                      onClick={this.handleCloseAlert}
                      className="center_button"
                    >
                      {translate('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>
        <Modal open={this.state.isOpenMDL} onClose={this.handleMDLClose}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{translate('modal.title.attention')}</h2>
                <p className="text">
                  {translate('modal.message.delete_ldap')}
                </p>
                <p className="small_text">
                  {translate('modal.message.delete_ldap_sub')}
                </p>
                <div className="button_wrap">
                  <a onClick={this.handleMDLClose} className="left_button">
                    {translate('modal.button.cancel')}
                  </a>
                  <a
                    onClick={this.handleDeleteLDAP}
                    className="right_button"
                  >
                    {translate('modal.button.delete')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Modal>
    );
  }
}

export default inject('state')(observer(EditLDAPModal));
